import { render } from "./staff_panel.vue?vue&type=template&id=c151fc6a"
import script from "./staff_panel.js?vue&type=script&lang=js&external"
export * from "./staff_panel.js?vue&type=script&lang=js&external"

import "./staff_panel.vue?vue&type=style&index=0&id=c151fc6a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__